// banner
export function banner() {

    let isSectionVisible = false;

    $(document).scroll(function() {
        console.log(isSectionVisible);
        if ($(window).width() > 1200) {
            if (isSectionVisible) {
                $('.banner').removeClass('active');
            } else {
                $('.banner').addClass('active');
            }
        }
    });


    let callback = function (entries) {
        let entry = entries[0];
        isSectionVisible = entry.isIntersecting;
    };

    let observer = new IntersectionObserver(callback);

    let target = document.querySelector('body');
    observer.observe(target);
}


// WEBPACK FOOTER //
// ./assets/js/modules/banner.js